export type RoleAssignmentContextType = (typeof RoleAssignmentContextType)[keyof typeof RoleAssignmentContextType];

export const RoleAssignmentContextType = {
    Global: 'Global',
    Group: 'Group',
    Tenant: 'Tenant',
    Client: 'Client',
    Application: 'Application',
    ApiResource: 'ApiResource',
    ApiResourceRole: 'ApiResourceRole',
    User: 'User',
    ApiResourceScope: 'ApiResourceScope',
    IdentityRole: 'IdentityRole',
} as const;
